module.exports = __webpack_public_path__ + "media/iconic/x-43a4ea62.svg";